// Components
import { addToast } from "../../components/toasts";

// Models
import { StudyDegree } from "../../models/study-degree";
import { Study } from "../../models/study";

// Resources
import { catchError } from "../../catchErrors";

// Settings
import {
  finishAddFormationModal,
  onCloseModalExperiences,
  onCloseModalFormations,
  onCloseModalKillerQuestions,
  stepper,
} from "./offer-detail";
import { COUNTRY_KEY } from "../../settings";

// Requests
import {
  addFormationRequest,
  getHasRegulatedTraining,
  getStudies as getStudiesRequest,
  getStudiesDegrees as getStudiesDegreesRequest,
  setHaveNoRegulatedTraining,
} from "./requests";
import { NEW_FORMATION_TOAST } from "./settings";
import { GENERAL_ERROR } from "../../resources";
import { addModalCloseCallback, removeModalCloseCallback, showModal, EuiModalSize } from "../../components/modal";
import { disableDropdown, enableDropdown, getDropdownValue, resetDropdown } from "../../components/dropdown";
import { disableInput, enableInput } from "../../components/input";

const applyOfferModal = () => $("#applyOfferModal");
const haveFormationYesButton = () => $("#haveFormationsYes");
const haveFormationsNoButton = () => $("#haveFormationsNo");
const addFormationButton = () => $("#addFormationButton");
const periodSelector = () => $("#periodSelector");
const periodSelectorInput = () => $("#periodInput");
const workingHereSwitch = () => $("#DatesFormationSwitch");

const offerTitle = () => $("#offerDetailSettings").attr("data-OFFER_TITLE")!;
const offerDescription = () =>
  $("#offerDetailSettings").attr("data-OFFER_LOCATION")!;

const STUDY_DEGREE_SELECTOR = "#studyDegreeSelector";
const STUDY_SELECTOR = "#studySelector";
const PERIOD_SELECTOR = "#periodSelector";

$(() => {
  workingHereSwitch().on("change", (event) => {
      const switchElement = event.target as HTMLInputElement;
      const isSwitchEnabled = switchElement.checked;
  
      isSwitchEnabled ? enableDropdown(periodSelector()) : disableDropdown(periodSelector());
      resetDropdown(periodSelector());
      handleDateEndValidation();
      emptyDateFormation();
    });
})

export async function getHaveFormation(): Promise<boolean> {
  try {
    const hasFormations: boolean = await getHasRegulatedTraining();
    return hasFormations;
  } catch (error) {
    catchError(error);
    return false;
  }
}

export function showAddFormationModal() {
  haveFormationYesButton().off("click", showNewFormationStep);
  haveFormationsNoButton().off(
    "click",
    setHaveNoRegulatedTrainingAndCloseModal
  );
  haveFormationYesButton().on("click", showNewFormationStep);
  haveFormationsNoButton().on("click", setHaveNoRegulatedTrainingAndCloseModal);

  removeModalCloseCallback('#applyOfferModal', onCloseModalExperiences);
  removeModalCloseCallback('#applyOfferModal', onCloseModalFormations);
  removeModalCloseCallback('#applyOfferModal', onCloseModalKillerQuestions);
  addModalCloseCallback('#applyOfferModal', onCloseModalFormations);

  $("#experienceOfferTitle").text(offerTitle());
  $("#experienceOfferLocation").text(offerDescription());

  showModal('#applyOfferModal', { isFullScreen: true, overlayClose: false, size: EuiModalSize.S });
  window.dataLayer?.push({
    event: "PedirFormacionOferta",
  });
}

export async function showNewFormationStep() {
  if (COUNTRY_KEY !== "PT") {
    const studiesDegrees: Array<StudyDegree> = await getStudiesDegrees();

    let studyDegreeHTML: string = "";
    $(`${STUDY_DEGREE_SELECTOR} .eui-dropdown__options-body`).html();
      studiesDegrees.forEach((studyDegree: StudyDegree) => {
        studyDegreeHTML += `<li class="eui-d-flex eui-d-flex--vertical-center eui-cursor-pointer eui-dropdown__option" data-eui-value="${studyDegree.id}">
        ${studyDegree.description}
      </li>`
    });
    $(`${STUDY_DEGREE_SELECTOR} .eui-dropdown__options-body`).html(studyDegreeHTML);

    $(`${STUDY_DEGREE_SELECTOR} .eui-dropdown .eui-input`).on("change", (event) => {
      resetDropdown($(`${STUDY_SELECTOR}`));
      const target: HTMLInputElement = <HTMLInputElement>event.target;
      const value = $(target).attr("eui-dropdown-val")!;
      loadStudies(value);
    });

    disableDropdown($(STUDY_SELECTOR));
    resetDropdown($(`${STUDY_SELECTOR}`));
  } else {
    loadStudies("-1");
    $(STUDY_DEGREE_SELECTOR).hide();
  }

  $("#addFormationForm").validate();
  const formSettings = $.data($("#addFormationForm")[0], "validator").settings;

  formSettings.submitHandler = (form: any) => {
    $("input", form).blur();
    const validator = $("#addFormationForm").validate();
    addFormation();
  };

  stepper.next();
}

async function setHaveNoRegulatedTrainingAndCloseModal() {
  await setHaveNoRegulatedTraining();
  if(window.addBrazeEvent) window.addBrazeEvent("B2C - Update profile");
  closeFormationModal();
}

function closeFormationModal() {
  finishAddFormationModal();
}

async function getStudiesDegrees(): Promise<Array<StudyDegree>> {
  const studiesDegrees: Array<StudyDegree> = await getStudiesDegreesRequest();
  return studiesDegrees;
}

async function getStudies(studyDegree: string) {
  const studies = await getStudiesRequest(studyDegree);
  return studies;
}

async function loadStudies(studyDegree: string) {
  const studies: Array<Study> = await getStudies(studyDegree);

  let studiesHTML: string = '';
  $(`${STUDY_SELECTOR} .eui-dropdown__options-body`).html();
  studies.forEach((study: Study) => {
    studiesHTML += `<li class="eui-d-flex eui-d-flex--vertical-center eui-cursor-pointer eui-dropdown__option" data-eui-value="${study.id}">
      ${study.description}
    </li>`
  });
  $(`${STUDY_SELECTOR} .eui-dropdown__options-body`).html(studiesHTML);
  enableDropdown($(STUDY_SELECTOR));
}

async function addFormation() {
  addFormationButton().prop("disabled", true);
  const studyDegree: { value: string; text: string } = getDropdownValue(STUDY_DEGREE_SELECTOR)!;
  const study: { value: string; text: string } = getDropdownValue(STUDY_SELECTOR)!;
  const period: { value: string; text: string } = getDropdownValue(PERIOD_SELECTOR);

  let formInvalid = !studyDegree.value || !study.value;

  if (COUNTRY_KEY == "PT") {
    formInvalid = !study.value;
  }

  if (formInvalid) {
    addFormationButton().prop("disabled", false);
    addToast(GENERAL_ERROR, "error", 2000);
    return;
  }

  try {
    await addFormationRequest(studyDegree.value.toString(), study.value, period ? Number(period?.value) : undefined);
    addToast(NEW_FORMATION_TOAST, "success", 2000);
    if(window.addBrazeEvent) window.addBrazeEvent("B2C - Update profile");
    closeFormationModal();
  } catch (error: any) {
    addFormationButton().prop("disabled", false);
    addToast(GENERAL_ERROR, "error", 2000);
  }
}

function handleDateEndValidation() {
  const isSwitchEnabled = workingHereSwitch().is(':checked');
  
  if (isSwitchEnabled) {
      const validationMessage = periodSelectorInput().attr('data-val-required-old')?.toString()!;
      periodSelectorInput().removeAttr('data-val-required-old');
      periodSelectorInput().rules('add', {
          required: true,
          messages: {
              required: validationMessage
          }
      });
  } else {
      const validationMessage = periodSelectorInput().attr('data-val-required')?.toString()!;
      periodSelectorInput().attr('data-val-required-old', validationMessage);
      periodSelectorInput().rules('remove', 'required');
  }
}

function emptyDateFormation() {
  periodSelector().val('');
  const changeEvent = new Event("change", { bubbles: true });
  periodSelector()[0].dispatchEvent(changeEvent);
}